import {
  PageResponse,
  PageData,
  TMSPalletVo,
  TMSPalletSearchParams,
} from "@/types";
import { APIRequest } from "@/utils/api";

const PalletAPI = new APIRequest({
  baseURL: "/api/wms/v2/tms/pallets",
});

export async function queryPallets(
  params: TMSPalletSearchParams,
): Promise<PageData<TMSPalletVo>> {
  return PalletAPI.get<PageResponse<TMSPalletVo>>({
    url: "",
    params,
  }).then((res) => res.data);
}
